import { isFeatureEnabled } from "./appConfigurations";

// Gates the split of the old dashboard into Dashboard (header tiles and system
// messages) and Sites (list and map), CS AB#49661. Off = the dashboard as it
// was before, with no Sites entry in the sidebar.
export const SPLIT_DASHBOARD_FEATURE_FLAG = "CS_49661_SPLIT_DASHBOARD";

export const selectSplitDashboardEnabled = isFeatureEnabled(
  SPLIT_DASHBOARD_FEATURE_FLAG
);
